import React from 'react';

const SocialPlatformIcon = ({ platform, size = 18, className = '' }) => {
  const commonProps = {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    'aria-hidden': true,
    className
  };

  if (platform === 'instagram') {
    return (
      <svg {...commonProps} fill="none" stroke="currentColor" strokeWidth="1.9">
        <rect x="3" y="3" width="18" height="18" rx="5" />
        <circle cx="12" cy="12" r="4" />
        <circle cx="17.4" cy="6.6" r="1" fill="currentColor" stroke="none" />
      </svg>
    );
  }

  if (platform === 'facebook') {
    return (
      <svg {...commonProps} fill="currentColor">
        <path d="M13.7 22v-8h2.8l.4-3.2h-3.2v-2c0-.9.3-1.6 1.7-1.6h1.7V4.4c-.3 0-1.4-.1-2.6-.1-2.6 0-4.4 1.6-4.4 4.4v2.1H8.2V14h2.9v8h2.6Z" />
      </svg>
    );
  }

  if (platform === 'linkedin') {
    return (
      <svg {...commonProps} fill="currentColor">
        <rect x="3" y="3" width="18" height="18" rx="2.4" fill="none" stroke="currentColor" strokeWidth="1.7" />
        <circle cx="7.4" cy="8" r="1.2" />
        <path d="M6.2 10.3h2.4v7.3H6.2v-7.3Zm4.2 0h2.3v1c.7-.9 1.5-1.3 2.6-1.3 2.1 0 3.1 1.3 3.1 3.7v3.9H16v-3.5c0-1.3-.4-2-1.4-2-1.1 0-1.7.8-1.7 2.3v3.2h-2.5v-7.3Z" />
      </svg>
    );
  }

  return (
    <svg {...commonProps} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <path d="M5 4l14 16M19 4 5 20" />
    </svg>
  );
};

export default SocialPlatformIcon;
